/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ServerIdentityImpactServer,
  ServerIdentityImpactServer$inboundSchema,
} from "./serveridentityimpactserver.js";

/**
 * The MCP servers and gateways, other than the target, that a proposed binding change affects.
 */
export type ServerIdentityImpactResult = {
  /**
   * MCP servers and gateways the caller cannot read; they are not named. When the change touches an organization-level client this counts every such server on the issuer, affected or not.
   */
  hiddenServerCount: number;
  /**
   * Affected MCP servers the caller can read.
   */
  servers: Array<ServerIdentityImpactServer>;
};

/** @internal */
export const ServerIdentityImpactResult$inboundSchema: z.ZodMiniType<
  ServerIdentityImpactResult,
  unknown
> = z.pipe(
  z.object({
    hidden_server_count: z.int(),
    servers: z.array(ServerIdentityImpactServer$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "hidden_server_count": "hiddenServerCount",
    });
  }),
);

export function serverIdentityImpactResultFromJSON(
  jsonString: string,
): SafeParseResult<ServerIdentityImpactResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServerIdentityImpactResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServerIdentityImpactResult' from JSON`,
  );
}
